/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/MasterUpload.xlsx";
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'
import DPSwitch from 'framework/components/DPSwitch'

const SizeMasterContent = ({
    CodeValue,
    CodeonChange,
    DescValue,
    DescOnChange,
    DispValue,
    DispOnChange,
    disabled,

    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    CodeOnBlur,
    ErrorMsg,
    menuName,
    onButtonClick,
    btnDisable,
    SearchDisable,
    showFileUpload,
    valueUpload,
    menuCode,
    autoCode,
    ActiveSw,
    SwonChange
}) => {

    const ApiURL = window.Links.ApiURL
    //*** End of useStates */

    async function tog_backdrop() {
        modelTrigger();
    }

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">
                                <DPTextBoxButton
                                    rowClass="mb-4-sm"
                                    labelText="Code *"
                                    textType="text"
                                    maxLength="5"
                                    value={CodeValue}
                                    onChange={CodeonChange}
                                    onBlur={CodeOnBlur}
                                    disabled={disabled == true ? disabled : disabledCode}
                                    onButtonClick={onButtonClick}
                                    btnDisable={disabled == true ? disabled : btnDisable}
                                    placeholder={autoCode}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Description *"
                                    textType="text"
                                    maxLength="50"
                                    value={DescValue}
                                    onChange={DescOnChange}
                                    disabled={disabled}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Display *"
                                    textType="text"
                                    maxLength="50"
                                    value={DispValue}
                                    onChange={DispOnChange}
                                    disabled={disabled}
                                />
                                <Row>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Active
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SwonChange}
                                            checked={ActiveSw}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm">
                                <Button
                                    onClick={() => {
                                        tog_backdrop()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                    disabled={SearchDisable}
                                >
                                    <i
                                        className="mdi mdi-search-web"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>
                            </Col>
                            <Col sm={12} md={2} className="mb-4-sm">
                                <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <input
                                            id="file"
                                            type="file"
                                            onChange={showFileUpload}
                                            value={valueUpload}
                                            disabled={disabledCode}
                                            accept=".xlsx, .xls, .csv"
                                            style={{ display: "none" }}
                                        />

                                        <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                                            <span >
                                                <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                            </span>
                                        </label></li>

                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                                            style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                                            <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                                        </a></li>
                                </ul>
                            </Col>


                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={[]}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"SIZE"}
                                MenuCode={menuCode}
                                KeyVal={"SIZ"}
                                searchBy={"VR_CODE"}
                                FilterStr={"a"}
                            />



                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

export default SizeMasterContent